import * as actionTypes from './actionTypes';
import reduce from '../reduce';

const initialState = {
    projApolloRuns: [],
    count: 0,
    page: 1,
    pageSize: 10,
    pages: 0,
    sortField: 'created_at',
    sortOrder: 'desc',
    search: null,
    error: '',
    crowdGroupId: null,
    jobRunId: null,
    projApolloHdrDatasets: [],
    hdrCount: 0,
    hdrPage: 1,
    hdrPageSize: 10,
    hdrPages: 0,
    hdrSortField: 'created_at',
    hdrSortOrder: 'desc',
    hdrSearch: null,
    hdrError: '',
    vdpHdrDatasetId: null,
    projApolloItemDatasets: [],
    itemCount: 0,
    itemPage: 1,
    itemPageSize: 10,
    itemPages: 0,
    itemSortField: 'created_at',
    itemSortOrder: 'desc',
    itemSearch: null,
    itemError: '',
    projApolloXmls: [],
    xmlCount: 0,
    xmlPage: 1,
    xmlPageSize: 10,
    xmlPages: 0,
    xmlSortField: 'created_at',
    xmlSortOrder: 'desc',
    xmlSearch: null,
    xmlError: '',
}

const receivedProjApolloRunsData=(state, action)=>{
    const { projApolloRuns,count,page,pageSize,pages,sortField,sortOrder,search,crowdGroupId } = action.data;
    return {
        ...state,
        projApolloRuns: projApolloRuns,
        count: count,
        page: page,
        pageSize: pageSize,
        pages: pages,
        sortField: sortField,
        sortOrder: sortOrder,
        search: search,
        crowdGroupId: crowdGroupId
    }
}

const getProjApolloRunsError=(state, action)=> {
    return {
        ...state,
        error: action.error
    }
}

const receivedProjApolloHdrDatasetData=(state, action)=>{
    const { jobRunId,projApolloHdrDatasets,count,page,pageSize,pages,sortField,sortOrder,search } = action.data;
    return {
        ...state,
        jobRunId: jobRunId,
        projApolloHdrDatasets: projApolloHdrDatasets,
        hdrCount: count,
        hdrPage: page,
        hdrPageSize: pageSize,
        hdrPages: pages,
        hdrSortField: sortField,
        hdrSortOrder: sortOrder,
        hdrSearch: search
    }
}

const getProjApolloHdrDatasetsError=(state, action)=> {
    return {
        ...state,
        hdrError: action.error
    }
}

const receivedProjApolloItemDatasetData=(state, action)=>{
    const { vdpHdrDatasetId,projApolloItemDatasets,count,page,pageSize,pages,sortField,sortOrder,search } = action.data;
    return {
        ...state,
        vdpHdrDatasetId: vdpHdrDatasetId,
        projApolloItemDatasets: projApolloItemDatasets,
        itemCount: count,
        itemPage: page,
        itemPageSize: pageSize,
        itemPages: pages,
        itemSortField: sortField,
        itemSortOrder: sortOrder,
        itemSearch: search
    }
}

const getProjApolloItemDatasetsError=(state, action)=> {
    return {
        ...state,
        itemError: action.error
    }
}

const receivedProjApolloXmlsData=(state, action)=>{
    const { projApolloXmls,count,page,pageSize,pages,sortField,sortOrder,search } = action.data;
    return {
        ...state,
        projApolloXmls: projApolloXmls,
        xmlCount: count,
        xmlPage: page,
        xmlPageSize: pageSize,
        xmlPages: pages,
        xmlSortField: sortField,
        xmlSortOrder: sortOrder,
        xmlSearch: search
    }
}

const getProjApolloXmlsError=(state, action)=> {
    return {
        ...state,
        xmlError: action.error
    }
}

export default reduce(initialState,{
    [actionTypes.GET_PROJAPOLLO_RUNS_DATA]: receivedProjApolloRunsData,
    [actionTypes.GET_KEYPOINT_DATA_ERROR]: getProjApolloRunsError,
    [actionTypes.GET_PROJAPOLLO_HDR_DATASETS_DATA]: receivedProjApolloHdrDatasetData,
    [actionTypes.GET_PROJAPOLLO_HDR_DATASETS_DATA_ERROR]: getProjApolloHdrDatasetsError,
    [actionTypes.GET_PROJAPOLLO_ITEM_DATASETS_DATA]: receivedProjApolloItemDatasetData,
    [actionTypes.GET_PROJAPOLLO_ITEM_DATASETS_DATA_ERROR]: getProjApolloItemDatasetsError,
    [actionTypes.GET_PROJAPOLLO_XMLS_DATA]: receivedProjApolloXmlsData,
    [actionTypes.GET_PROJAPOLLO_XMLS_DATA_ERROR]: getProjApolloXmlsError
});


// WEBPACK FOOTER //
// ./src/redux/projApollo/reducer.js